export class InputLine {
  size: number

  constructor({ size = 20 }: { size?: number } = {}) {
    this.size = size
  }

  height(): number {
    return this.size * 2 + 1
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): number {
    ctx.fillStyle = 'black'
    ctx.fillRect(0, top + this.size, width, 1)
    return this.size * 2 + 1
  }
}
